import {Box, Link as MuiLink, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";

export default function OcorrenciasGeradas({ocorrencias = []}) {
    if (!ocorrencias.length) {
        return null;
    }

    return (
        <Stack spacing={1}>
            <Typography variant="subtitle2">Ocorrências geradas</Typography>
            {ocorrencias.map((ocorrencia) => (
                <Box key={ocorrencia.id}>
                    <MuiLink
                        component={Link}
                        to={`/eventos/${ocorrencia.id}`}
                        underline="hover"
                    >
                        #{ocorrencia.id} {ocorrencia.eventoAtual}
                    </MuiLink>
                    <Typography variant="caption" color="text.secondary" ml={1}>
                        {ocorrencia.estadoEnvio}
                    </Typography>
                </Box>
            ))}
        </Stack>
    );
}
